<template>
    <em
        v-if="!value"
        class="text-info"
        v-text="text"
    />

    <span v-else>
        {{ value }}
    </span>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        text: {
            type: String,
            default: 'None',
        },
    },
};
</script>
